import { CardContent, Typography } from '@mui/material';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const RichTextEditor = ({ formik, label, name }) => {

    const handleChange = (content) => {
        formik.setFieldValue(name, content);
    };

    return (
        <CardContent sx={{ padding: 0 }}>
            <Typography variant="h5" component="h2" className="mb-4 !text-base text-gray-500">
                {label}
            </Typography>
            <ReactQuill
                value={formik.values[name] || ''}
                onChange={handleChange}
                theme="snow"
                modules={RichTextEditor.modules}
                formats={RichTextEditor.formats}
                className="mb-4"
            />
        </CardContent>
    );
};

RichTextEditor.modules = {
    toolbar: [
        [{ 'header': '1' }, { 'header': '2' }, { 'font': [] }],
        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
        ['bold', 'italic', 'underline'],
        [{ 'align': [] }],
        ['link', 'image'],
        [{ 'color': [] }, { 'background': [] }],
        [{ 'script': 'sub' }, { 'script': 'super' }],
        [{ 'indent': '-1' }, { 'indent': '+1' }],
        ['clean']
    ],
};

RichTextEditor.formats = [
    'header', 'font', 'list', 'bullet', 'bold', 'italic', 'underline', 'align',
    'link', 'image', 'color', 'background', 'script', 'indent', 'clean'
];

export default RichTextEditor;
